import "./spinner.scss";

export default function Loader({ fullPage = false }) {
  return (
    <div
      className={`adminRippleLoader${fullPage ? " adminRippleLoader--fullPage" : ""}`}
      aria-busy="true"
      aria-label="Loading content"
    >
      <div className="adminRippleLoader__ripple">
        <div />
        <div />
      </div>
    </div>
  );
}
